var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreyValueChain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3530_26480)",
    filter: "url(#filter0_d_3530_26480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 11.8667H19.3333V10.5333H23.3333C25.2 10.5333 26.6667 8.99999 26.6667 7.19999C26.6667 5.39999 25.1333 3.86666 23.3333 3.86666H8V2.53333H23.3333C25.9333 2.53333 28 4.59999 28 7.19999C28 9.79999 25.9333 11.8667 23.3333 11.8667Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8667 19.9333H8.66667C6.06667 19.9333 4 17.8667 4 15.2667C4 12.6667 6.06667 10.6 8.66667 10.6H12.6667V11.9333H8.66667C6.8 11.9333 5.33333 13.4667 5.33333 15.2667C5.33333 17.0667 6.86667 18.6 8.66667 18.6H18.8V19.9333H18.8667Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3999 22.0667L16.4666 21.1333L18.3332 19.2667L16.4666 17.3333L17.3999 16.4L20.2666 19.2667L17.3999 22.0667Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5332 23.6L23.9999 22.9333C23.5999 22.4 21.4666 19.7333 21.4666 18.2667C21.4666 16.6 22.7999 15.2667 24.4666 15.2667C26.1332 15.2667 27.4666 16.6 27.4666 18.2667C27.4666 19.7333 25.3999 22.4 24.9332 22.9333L24.5332 23.6ZM24.5332 16.6C23.5999 16.6 22.8666 17.3333 22.8666 18.2667C22.8666 18.8667 23.7332 20.3333 24.5332 21.4C25.3332 20.2667 26.1999 18.8667 26.1999 18.2667C26.1999 17.3333 25.4666 16.6 24.5332 16.6Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53333 5.73332C5.13333 5.73332 4 4.59999 4 3.19999C4 1.79999 5.13333 0.666656 6.53333 0.666656C7.93333 0.666656 9.06667 1.79999 9.06667 3.19999C9.06667 4.59999 7.93333 5.73332 6.53333 5.73332ZM6.53333 1.99999C5.86667 1.99999 5.33333 2.53332 5.33333 3.19999C5.33333 3.86666 5.86667 4.39999 6.53333 4.39999C7.2 4.39999 7.73333 3.86666 7.73333 3.19999C7.73333 2.53332 7.2 1.99999 6.53333 1.99999Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.2H12V7.26666H20V15.2ZM13.3333 13.8667H18.6667V8.6H13.3333V13.8667Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 7.93332H15.3333V9.79999H16.6666V7.93332Z",
    fill: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2 17.8667H23.8667V18.8H25.2V17.8667Z",
    fill: "#C3C3C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3530_26480",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3530_26480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3530_26480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3530_26480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyValueChain);
export default __webpack_public_path__ + "static/media/greyValueChain.6214792e5498041c90b3dac1a74d8863.svg";
export { ForwardRef as ReactComponent };